import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {CartIcon, Typography} from '@customink/pigment-react';

import './index.scss';

const propTypes = {
  cartItemCount: PropTypes.number,
  subTotal: PropTypes.number,
  onClickHandler: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class ShoppingCartIcon extends PureComponent {
  static propTypes = propTypes;

  static defaultProps = {
    onClickHandler: () => {},
    cartItemCount: 0
  };

  render() {
    const {onClickHandler, cartItemCount} = this.props;
    const className = 'ndx-ShoppingCartIcon';
    const iconClassName = `${className}-icon`;
    const textClassName = `${className}-text`;
    return (
      <div className={className} onClick={onClickHandler}>
        <div className={iconClassName}>
          <div className="ndx-ShoppingCartIcon-svg">
            <CartIcon />
            {cartItemCount > 0 && (
              <div className="ndx-ShoppingCartIcon-count">{cartItemCount}</div>
            )}
          </div>
        </div>
        <Typography variant="uiTextTiny" className={textClassName}>
          Cart
        </Typography>
      </div>
    );
  }
}

export default ShoppingCartIcon;
